import React, { SVGProps } from 'react';

const WageredAmountIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 25 26"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_24860_244245)">
				<path
					d="M16.7787 1.55564L8.64352 5.193C7.80109 5.56966 7.42422 6.55863 7.80176 7.40194L11.4476 15.5456C11.8251 16.3889 12.8141 16.7672 13.6565 16.3906L21.7917 12.7532C22.6342 12.3765 23.011 11.3876 22.6335 10.5443L18.9877 2.40057C18.6101 1.55727 17.6212 1.17898 16.7787 1.55564Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.2461 8.26895C12.6673 8.08062 12.8557 7.58613 12.667 7.16447C12.4782 6.74282 11.9837 6.55367 11.5625 6.74201C11.1413 6.93034 10.9528 7.42482 11.1416 7.84648C11.3304 8.26813 11.8249 8.45728 12.2461 8.26895Z"
					stroke="currentColor"
				/>
				<path
					d="M15.5581 9.73672C15.9793 9.54839 16.1677 9.0539 15.979 8.63225C15.7902 8.21059 15.2957 8.02145 14.8745 8.20978C14.4533 8.39811 14.2648 8.8926 14.4536 9.31425C14.6424 9.7359 15.1369 9.92505 15.5581 9.73672Z"
					stroke="currentColor"
				/>
				<path
					d="M18.8725 11.2035C19.2938 11.0152 19.4822 10.5207 19.2934 10.099C19.1047 9.67739 18.6102 9.48825 18.1889 9.67658C17.7677 9.86491 17.5793 10.3594 17.7681 10.781C17.9568 11.2027 18.4513 11.3918 18.8725 11.2035Z"
					stroke="currentColor"
				/>
				<path
					d="M6.50398 16.2179C6.97567 16.2179 7.35806 15.8355 7.35806 15.3638C7.35806 14.8921 6.97567 14.5098 6.50398 14.5098C6.03229 14.5098 5.6499 14.8921 5.6499 15.3638C5.6499 15.8355 6.03229 16.2179 6.50398 16.2179Z"
					stroke="currentColor"
				/>
				<path
					d="M6.50398 21.3419C6.97567 21.3419 7.35806 20.9596 7.35806 20.4879C7.35806 20.0162 6.97567 19.6338 6.50398 19.6338C6.03229 19.6338 5.6499 20.0162 5.6499 20.4879C5.6499 20.9596 6.03229 21.3419 6.50398 21.3419Z"
					stroke="currentColor"
				/>
				<path
					d="M9.06502 18.7794C9.53671 18.7794 9.91909 18.3971 9.91909 17.9254C9.91909 17.4537 9.53671 17.0713 9.06502 17.0713C8.59332 17.0713 8.21094 17.4537 8.21094 17.9254C8.21094 18.3971 8.59332 18.7794 9.06502 18.7794Z"
					stroke="currentColor"
				/>
				<path
					d="M11.6275 21.3419C12.0992 21.3419 12.4816 20.9596 12.4816 20.4879C12.4816 20.0162 12.0992 19.6338 11.6275 19.6338C11.1558 19.6338 10.7734 20.0162 10.7734 20.4879C10.7734 20.9596 11.1558 21.3419 11.6275 21.3419Z"
					stroke="currentColor"
				/>
				<path
					d="M13.2079 16.4525C12.4383 16.7648 11.4233 16.4525 10.9995 15.4822L9.54954 11.6631H4.5104C3.56701 11.6631 2.80225 12.4279 2.80225 13.3712V22.4814C2.80225 23.4248 3.56701 24.1896 4.5104 24.1896H13.6206C14.564 24.1896 15.3287 23.4248 15.3287 22.4814L15.2467 15.6696L13.2079 16.4525Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_24860_244245">
					<rect
						width="25"
						height="25"
						fill="white"
						transform="translate(0 0.25)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default WageredAmountIcon;
